import * as yup from 'yup';

import { Model as ClientModel } from 'models/user/interface';

import { EndpointError, endpoint } from '../endpoint';
import { ERROR as VALIDATION_ERROR } from '../validation';

export type SignInViaAuthTokenParams = {
  password: string;
  token: string;
  roomId: string;
};
export type SignInViaAuthTokenResult = ClientModel & { token: string };
export type SignInViaAuthTokenError = EndpointError;

export const validationSchema: yup.SchemaOf<SignInViaAuthTokenParams> = yup.object().shape({
  password: yup.string().oneOf(['droramir2024'], VALIDATION_ERROR.INVALID_VALUE).required(VALIDATION_ERROR.REQUIRED),
  token: yup.string().required(VALIDATION_ERROR.REQUIRED),
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
});

export const signInWithToken = endpoint<SignInViaAuthTokenParams, SignInViaAuthTokenResult, SignInViaAuthTokenError>({
  method: 'POST',
  url: () => `/auth/client-with-token`,
});
